import React from 'react';
import type { ISiteContext } from '../models/site-context';
import type { FunctionComponent, ReactNode } from 'react';

const SiteContext = React.createContext<ISiteContext | null>(null);

export const SiteContextProvider: FunctionComponent<{
  site: ISiteContext;
  children: ReactNode;
}> = ({ site, children }) => (
  <SiteContext.Provider value={site}>{children}</SiteContext.Provider>
);

export const useSiteContext = () => React.useContext(SiteContext);
